import { recieveOrgConfig } from "./reducer";
import { APIClient, getLoggedinUser } from "../../../helpers/api_helper";
const api = new APIClient();

/**
 * Load the org's behaviour config on app start.
 *
 * The login/refresh payload also carries `organization`, but it is cached in
 * localStorage and a page reload never re-reads it — so any config key added
 * after a user's last login would stay invisible until they logged out and back
 * in. Fetching here makes a deploy enough.
 */
export const loadOrgConfig = () => async (dispatch) => {
  try {
    const data = await api.get("/api/organization/current/");

    if (data) {
      // Keep localStorage in step, so the synchronous getOrgConfig() — used at
      // module scope, where a hook cannot run — is fresh from the next load on.
      const user = getLoggedinUser();
      if (user) {
        localStorage.setItem(
          "authUser",
          JSON.stringify({ ...user, organization: data })
        );
      }
      dispatch(recieveOrgConfig(data.config || {}));
    }
  } catch (error) {
    console.error("Unable to load organization config!", error);
  }
};
